<template>
    <div class="vgt-global-search vgt-clearfix">
        <!-- <div class="vgt-global-search__input vgt-pull-left"> -->
        <div class="vgt-global-search__input pl-0">
            <v-chip
                v-for="filter in getFilters()"
                @input="clearFilter(filter)"
                close
                ><div class="font-weight-medium">{{ filter.label }}</div>
                : {{ filter.value }}</v-chip
            >
            <div
                class="font-weight-regular pl-2"
                v-bind:class="{
                    'pt-3': !getFilters().length,
                    'pb-2 pt-1': getFilters().length
                }"
                v-if="headerMessage"
            >
                {{ headerMessage }}
            </div>
        </div>
        <div class="vgt-global-search__input" v-if="searchEnabled">
            <span v-if="searchEnabled" class="input__icon">
                <div class="magnifying-glass"></div>
            </span>
            <input
                v-if="searchEnabled"
                type="text"
                class="vgt-input vgt-pull-left"
                :placeholder="globalSearchPlaceholder"
                :value="value"
                @input="updateValue($event.target.value)"
                @keyup.enter="entered($event.target.value)"
            />
        </div>
        <div class="vgt-global-search__actions vgt-pull-right">
            <slot name="internal-table-actions"> </slot>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "VgtGlobalSearch",
    props: [
        "value",
        "searchEnabled",
        "globalSearchPlaceholder",
        "headerMessage",
        "filters",
        "filterTypes",
        "columns",
        "removeFilter"
    ],
    data() {
        return {
            globalSearchTerm: null
        };
    },
    computed: {
        showControlBar() {
            if (this.searchEnabled) return true;
            if (this.$slots && this.$slots["internal-table-actions"])
                return true;
            return false;
        }
    },
    methods: {
        updateValue(value) {
            this.$emit("input", value);
            this.$emit("on-keyup", value);
        },
        entered(value) {
            this.$emit("on-enter", value);
        },
        clearFilter(filter) {
            this.removeFilter(filter.field);
        },
        getFilters() {
            return Object.keys(this.filters)
                .map(key => {
                    const value = this.filters[key];

                    if (!value) return false;

                    return {
                        label: this.getFilterLabel(key),
                        field: key,
                        value: this.getFilterValue(key, value)
                    };
                })
                .filter(f => f.value);
        },
        getFilterLabel(field) {
            const fieldParts = field.split(".");

            const column = this.columns.find(
                c => c.field == fieldParts[0] && !c.isIcon
            );

            if (fieldParts.length > 1) {
                return column.label + "." + this.toTitleCase(fieldParts[1]);
            }

            return column.label;
        },
        getFilterValue(field, value) {
            const fieldParts = field.split(".");

            const column = this.columns.find(c => c.field == fieldParts[0]);

            if (column.type && column.type.toLowerCase() == "boolean") {
                return value == "true" ? "Yes" : "No";
            }

            if (column.type && column.type.toLowerCase() == "date") {
                return moment(value).format("L");
            }

            if (Array.isArray(value)) {
                return column.filterOptions.filterDropdownItems.find(
                    o => o.value.join(",") === value.join(",")
                ).text;
            }

            const displayValue =
                this.filterTypes[field] &&
                this.filterTypes[field].startsWith("IS NOT")
                    ? "NOT: " + value
                    : value;

            return displayValue;
        },
        toTitleCase(value) {
            return value.replace(/\b./g, txt => txt.charAt(0).toUpperCase());
        }
    }
};
</script>

<style>
.filter-tag {
    font-size: 14px;
    background: #eef2f5 !important;
    padding: 0px 8px 0px 8px;
    display: inline-block;
    margin: 0 2px 12px;
}
</style>
